import GcHeading from '@garmin/components-global/src/components/GcHeading/index.vue';
import ImgBanner from '../ImgBanner/index.vue';

export default {
  name: 'PcLearnMore',
  data() {
    return {
      className: 'app__learn-more',
    };
  },
  props: {
    bgImage: {
      type: String,
      default: '',
    },
    mobileBgImage: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    textAlign: {
      type: String,
      default: 'center',
    },
    link: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'dark',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  computed: {
    linkClassName() {
      return `${this.className}__link`;
    },
    containerClassName() {
      return `${this.className}__container`;
    },
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
    descriptionAlignClassName() {
      return `${this.className}__container__text__copy--${this.textAlign}`;
    },
    titleAlignClassName() {
      return `${this.className}__container__text__title--${this.textAlign}`;
    },
    titleClassName() {
      return `${this.className}__container__text__title`;
    },
    buttonTextClassName() {
      return `${this.className}__container__text__button`;
    },
    buttonTextContainerClassName() {
      return `${this.className}__container__text__button__container`;
    },
    containerTextClassName() {
      return `${this.className}__container__text`;
    },
    innerContainerClassName() {
      return `${this.className}__container__inner--${this.textAlign}`;
    },
    hasLink() {
      return !!this.link.length;
    },
    containerEl() {
      return this.hasLink ? 'a' : 'div';
    },
    linkTitle() {
      return this.hasLink ? this.buttonText : null;
    },
    linkUrl() {
      return this.hasLink ? this.link : null;
    },
    showBox() {
      return (this.title || this.description || this.buttonText);
    },
  },
  components: {
    ImgBanner,
    GcHeading,
  },
};
